module.exports = __webpack_public_path__ + "client-icon.png?89ff5cdaca3b196e6cbbf9f157edf584";